import { z } from "zod";
import { api, makeZodResponse } from ".";
import { QueuePanel, queuePanelSchema, QueueLogin, QueueStats, queueStatsResponse } from "../../types";

export const queueApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getQueuePanels: builder.query<QueuePanel[], string>({
            query: voip_user_uuid => ({
                method: 'GET',
                url: '/api/get-queue-panels',
                params: { voip_user_uuid }
            }),
            transformResponse: (response: { result: unknown }) => {
                const shape = makeZodResponse(z.array(queuePanelSchema));

                const validData = shape.safeParse(response);

                if (!validData.success || !validData.data) {
                    return [];
                }

                return validData.data.result;
            }
        }),
        getQueuePanelData: builder.query<Record<any, QueueStats>, { voip_user_uuid: string }>({
            query: ({ voip_user_uuid }) => ({
                method: "GET",
                url: "/api/get-panel-data",
                params: { voip_user_uuid }
            }),
            transformResponse: (response: { result: unknown }) => {
                const shape = makeZodResponse(z.record(queueStatsResponse));

                const validData = shape.safeParse(response);

                if (!validData.success) {
                    return {};
                }

                return validData.data.result;
            },
        }),
        putQueueLogins: builder.mutation<boolean, {
            voip_user_uuid: string,
            data: Pick<QueueLogin, 'login' | 'queue_id' | 'set_by'>
        }>({
            query: ({ voip_user_uuid, data }) => ({
                method: 'PUT',
                url: '/api/queue-login',
                params: {
                    voip_user_uuid
                },
                data
            }),
            transformResponse: (response: unknown) => {

                const shape = makeZodResponse(z.boolean());
                const validated = shape.safeParse(response);

                if (!validated.success) {
                    return false;
                }

                return validated.data.result;
            },
            invalidatesTags: (result, error, { voip_user_uuid }) => [
                { type: 'QueuePanels', id: voip_user_uuid }
            ]
        }),

        putQueueLoginForAgents: builder.mutation<boolean, {
            voip_user_uuid: string,
            data: Pick<QueueLogin, 'login' | 'queue_id' | 'set_by'>
        }>({
            query: ({ voip_user_uuid, data }) => ({
                method: 'PUT',
                url: '/api/queue-login',
                params: {
                    voip_user_uuid
                },
                data
            }),
            transformResponse: (response: unknown) => {
                const shape = makeZodResponse(z.boolean());
                const validated = shape.safeParse(response);

                if (!validated.success) {
                    return false;
                }

                return validated.data.result;
            },
            invalidatesTags: (result, error, { voip_user_uuid }) => [
                { type: 'QueuePanels', id: voip_user_uuid }
            ]
        }),
        getQueuePanelsForAgents: builder.query<any, string>({
            query: voip_user_uuid => ({
                method: 'GET',
                url: '/api/get-queue-panels',
                params: { voip_user_uuid }
            }),
            transformResponse: (response: { result: unknown }) => {
                const shape = makeZodResponse(z.array(queuePanelSchema));

                const validData = shape.safeParse(response);

                if (!validData.success || !validData.data) {
                    return [];
                }
                return validData.data.result;
            },
            providesTags: (result, error, voip_user_uuid) => [
                { type: 'QueuePanels', id: voip_user_uuid }
            ]
        }),
    }),
});

export const {
    useGetQueuePanelsQuery,
    useLazyGetQueuePanelDataQuery,
    usePutQueueLoginsMutation,
    usePutQueueLoginForAgentsMutation,
    useGetQueuePanelDataQuery,
    useGetQueuePanelsForAgentsQuery
} = queueApi;
